/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ListingComponent from "../../StyleComponents/ListingComponent";
import ListingTable from "./ListingTable";
import {
  get_monthlt_rent_srm,
  get_monthlt_rent_srm_paid,
  get_search_monthly_rent_srm,
  get_search_monthly_rent_srm_paid,
} from "../../../Services/Services";
import { useSelector } from "react-redux";

import SRMHamburger from "../SRMHAmburger";
import moment from "moment";

function MonthlyPayement() {
  const navigate = useNavigate();

  const { type } = useParams();

  const { auth, refresh } = useSelector((s) => s);

  const [agIDS, setAgIds] = useState([]);
  const [rentData, setRent] = useState({});

  //search
  const [searchValue, setsearchValue] = useState("");

  async function fetchData(id) {
    try {
      const data = await get_monthlt_rent_srm(id);
      if (data.data.success) {
        setAgIds(data.data.ids);
        setRent(data.data.agreement);
      } else {
        // TODO document why this block is empty
      }
    } catch (error) {}
  }

  async function fetchDataPaid(id) {
    try {
      const data = await get_monthlt_rent_srm_paid(id);
      if (data.data.success) {
        setAgIds(data.data.ids);
        setRent(data.data.agreement);
      } else {
        // TODO document why this block is empty
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (type === "in-process") {
      fetchData(auth.id);
    } else if (type === "paid") {
      fetchDataPaid(auth.id);
    }
    setsearchValue("");
  }, [refresh, type]);

  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const rows = agIDS.map((row) => {
    return {
      id: rentData[row].id,
      agreement_id: rentData[row].agreement_id,
      landlord_name: rentData[row].landlord_name,
      monthly_id: rentData[row].id,
      code: rentData[row].code,
      checkbox: rentData[row].status,
      status: rentData[row].status,
      utr: rentData[row].utr_no,
      manager: rentData[row].manager,
      name: rentData[row].landlord_name,
      location: rentData[row].location,
      gst: rentData[row].gst ? rentData[row].gst : "---",
      percentage: rentData[row].share,
      month_of_rent:
        month[new Date(rentData[row].rent_date).getUTCMonth()] +
        " " +
        new Date(rentData[row].rent_date).getFullYear(),
      rent_amount: parseInt(rentData[row].rent_amount),
      gst_fee: rentData[row].gst
        ? parseInt((rentData[row].rent_amount / 100) * 18)
        : 0,
      total_rent: rentData[row].gst
        ? parseInt(
            parseInt(rentData[row].rent_amount) +
              (parseInt(rentData[row].rent_amount) / 100) * 18
          )
        : parseInt(rentData[row].rent_amount),
      total_month_rent: parseInt(rentData[row].monthly_rent),
      rent_date: moment(rentData[row].rent_date).format("MMMM YY"),
    };
  });

  const filteredRow =
    searchValue.length === 0
      ? rows
      : rows.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchValue.toLowerCase()) > 0
        );

  async function SearchAPi(id, searchValue) {
    if (type === "in-process") {
      const search = await get_search_monthly_rent_srm(id, searchValue);
      if (search.status === 200) {
        setAgIds(search.data.ids);
        setRent(search.data.agreement);
      }
    } else if (type === "paid") {
      const search = await get_search_monthly_rent_srm_paid(id, searchValue);
      if (search.status === 200) {
        setAgIds(search.data.ids);
        setRent(search.data.agreement);
      }
    }
  }

  function handleSerachChange(e) {
    setsearchValue(e.target.value);
  }

  return (
    <>
      <Stack sx={{ flexWrap: "wap", flexDirection: "row" }}>
        <SRMHamburger />
        <ListingComponent
         title1={<header>RMS <span className="small-heading">(Rental Management System)</span></header>}
          title={
            type === "in-process"
              ? "Monthly Payment - In Process"
              : type === "paid"
              ? "Monthly Payment-Paid/Terminated"
              : "Monthly Payment"
          }
          buttonText="Upload"
          //   options={options}
          value={"New Agreement"}
          Table={ListingTable}
          rows={filteredRow}
          dropDown={false}
          searchValue={searchValue}
          setsearchValue={setsearchValue}
          handleSerachChange={handleSerachChange}
        />
      </Stack>
    </>
  );
}

export default MonthlyPayement;
